// NEW_FILE_JUSTIFIED: Coverage page header component — extracted from MyCoveragePage for reuse and 200-line limit compliance
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Download } from 'lucide-react';
import type { ICoveragePageHeaderProps } from '@/@types/coverage';

export function CoveragePageHeader({
  basePath,
  planName,
  onDownloadCertificate,
  canDownload,
}: ICoveragePageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-10 flex items-center justify-between bg-card border-b border-border px-8 py-5">
      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          size="sm"
          className="rounded-lg text-[13px] font-medium"
          onClick={() => navigate(basePath)}
        >
          <ArrowLeft aria-hidden="true" className="mr-1.5 h-4 w-4" />
          Back
        </Button>
        <div>
          <h1 className="text-[22px] font-semibold text-foreground">Coverage Details</h1>
          {planName && (
            <p className="text-sm text-muted-foreground mt-0.5">Plan: {planName}</p>
          )}
        </div>
      </div>
      <Button
        variant="outline"
        className="rounded-lg text-[13px] font-medium px-5 py-2.5"
        onClick={onDownloadCertificate}
        disabled={!canDownload}
      >
        <Download aria-hidden="true" className="mr-2 h-4 w-4" />
        Download Certificate
      </Button>
    </div>
  );
}
